<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
    Object.getPrototypeOf(
      this.$options.components
    ).ElSelect.options.methods.handleFocus = (event) => {

    };
  }
}
</script>

<style>
  body{
    margin: 0;
    padding: 0;
  }
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .el-select-dropdown__item{
    padding: 0 10px !important;
  }
  .el-popover{
    background: rgba(30, 50, 59, 0.8);
    border: 1px solid #fff;
  }
  .el-popover .popper__arrow{
    border-bottom-color: #fff !important;
  }
  .el-popover .popper__arrow::after{
    border-bottom-color: rgba(30, 50, 59, 0.8) !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue